import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { stringify } from 'query-string';

import { Link } from 'react-router-dom';
import Truncate from '@cityads/react-truncate';
import Rating from 'cityads-v3/components/Rating/Rating';
import NumberFormat, { FORMAT_CURRENCY, FORMAT_PERCENT } from 'cityads-v3/components/Format/NumberFormat';
import PaidFormat from 'cityads-v3/components/Format/PaidFormat';
import Typography from '@mui/material/Typography'

import classes from './OfferCard.scss';

import {
  getSubscriptionStatuses
} from 'cityads-v3/actions/subscriptionStatuses';

const cardOptions = t => [
  {
    name  : 'payment',
    header: t('commission'),
    render: 'renderPayment',
  },
  {
    name     : 'ar',
    header   : 'AR',
    precision: 0,
    format   : FORMAT_PERCENT,
  },
  {
    name  : 'cr',
    header: 'CR',
    format: FORMAT_PERCENT,
  }
];

const cardOptionsForNew = t => [
  {
    name  : 'payment',
    header: t('commission'),
    render: 'renderPayment',
  },
  {
    name  : 'subscriptionStatus',
    header: t('status'),
    render: 'renderStatus',
  },
];

@withTranslation(['main', 'Offers'], { i18n, wait: !!window })
export class OfferCard extends PureComponent {
  static propTypes = {
    offer    : PropTypes.object,
    stat     : PropTypes.object,
    isNew    : PropTypes.bool,
    isPopular: PropTypes.bool,
    t        : PropTypes.func,

    language                     : PropTypes.string,
    subscriptionStatus           : PropTypes.object,
    isLoadedSubscriptionStatuses : PropTypes.bool,
    isLoadingSubscriptionStatuses: PropTypes.bool,
  };

  componentDidMount() {
    const { dispatch, isLoadedSubscriptionStatuses, isLoadingSubscriptionStatuses } = this.props;

    if (!isLoadedSubscriptionStatuses && !isLoadingSubscriptionStatuses) {
      dispatch(getSubscriptionStatuses());
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { dispatch, language, isLoadingSubscriptionStatuses } = newProps;

    if (language !== this.props.language && !isLoadingSubscriptionStatuses) {
      dispatch(getSubscriptionStatuses());
    }
  }

  renderPayment() {
    return (
      <PaidFormat commissionData={this.props.offer.commission_data} />
    );
  }

  renderStatus() {
    const { subscriptionStatus } = this.props;

    return subscriptionStatus ? subscriptionStatus.status_name : null;
  }

  render() {
    const { offer, stat, isNew, t, id } = this.props;

    const options = isNew ? cardOptionsForNew(t) : cardOptions(t);

    const linkToOffer = `/publisher/offers?${stringify({ name: offer.name })}`

    return (
      <div className={classes.offerCard} id={id}>
        <div className={classes.title}>
          <Link to={linkToOffer}>{offer.name}</Link>
        </div>

        {offer.business_category_name &&
          <Typography
            color="textSecondary"
            component="div"
            className={classes.subTitle}
          >
            {offer.business_category_name}
          </Typography >
        }

        <Truncate lines={3} className={classes.text}>
          <div dangerouslySetInnerHTML={{ __html: offer.text }} />
        </Truncate>

        {
          offer.rating &&
            <div className={classes.rating}>
              <Rating level={offer.rating} />
            </div>
        }

        <div className={classes.description}>{offer.description}</div>

        <div className="offerCard__options">
          {options.map(({ name, header, render, format, precision }) => (
            <div key={name} className="offerCard__option">
              <Typography
                color="textSecondary"
                component="div"
                className="offerCard__option_title"
              >{header}</Typography>
              <div className="offerCard__option_value">
                {
                  render ?
                    this[render]() :
                    (
                      <NumberFormat
                        number    = {(format === FORMAT_PERCENT) ? stat[name] * 100 : stat[name]}
                        format    = {format}
                        precision = {precision}
                        currency  = {(format === FORMAT_CURRENCY) ? 1 : null}
                      />
                    )
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    language: state.language.language,
    subscriptionStatus: state.offers.subscription_status_byId[props.offer.subscription_status],
    isLoadedSubscriptionStatuses: state.subscriptionStatuses.isLoaded,
    isLoadingSubscriptionStatuses: state.subscriptionStatuses.isLoading,
  })
)(OfferCard)
